import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { getMaxPeriod } from '../../../utils/date';
import { SimpleChanges } from '../../../utils/types';
import { SubscriptionHandler } from '../../../advanced_campaign_booking.module/components/subscription-handler';
import { AuthService } from '../../../woo_services.module/AuthService';
import { CampaignService } from '../../../woo_services.module/CampaignService';
import { DashboardStore } from '../../../woo_services.module/DashboardStore';
import { TargetingService } from '../../../woo_services.module/TargetingService';
import {
  AgreementPart,
  Brand,
  Campaign,
  DatePeriod,
  Targeting,
  TargetingMetaData,
} from '../../../woo_services.module/shared-types';

@Component({
  selector: 'dashboard-details',
  templateUrl: './dashboard-details.component.html',
  styles: [
    `
      .table {
        border-bottom: 1px solid #dee2e6 !important;
      }
      .thead {
        border-bottom: 1px solid #dee2e6 !important;
      }
      .customer-comment {
        background-color: #f4f2f1;
        border-radius: 4px;
        padding: 0.75rem 1rem;
        font-style: italic;
      }
    `,
  ],
  standalone: false,
})
export class DashboardDetails extends SubscriptionHandler implements OnChanges, OnInit {
  campaignPeriod: DatePeriod = { start: null, end: null };

  @Input() campaign: Campaign;

  customerName: string;
  agencyName: string;
  campaignName: string;
  brand: Brand;
  additionalInfo: string;
  hasCustomerCommentAlert: boolean;
  targetingData: TargetingData[] = [];

  readonly adminOrPlanner: boolean;

  constructor(
    private targetingService: TargetingService,
    private authService: AuthService,
    private campaignService: CampaignService,
    private dashboardStore: DashboardStore,
  ) {
    super();
    this.adminOrPlanner = this.authService.adminOrPlanner();
  }

  ngOnInit(): void {
    this.addSubscription(this.dashboardStore.state$.subscribe(() => this.updateCustomerCommentAlert()));
  }

  ngOnChanges(changes: SimpleChanges<DashboardDetails>): void {
    if (changes.campaign && this.campaign) {
      this.customerName = this.campaign.customer_name;
      this.agencyName = this.campaign.agency_name;
      this.additionalInfo = this.campaign.additional_info;
      this.updateCustomerCommentAlert();
      this.campaignName = this.campaign.name;
      this.brand = this.campaign.brand;

      if (this.campaign.targetings) {
        this.campaignPeriod = getMaxPeriod(this.campaign.targetings);
        this.targetingData = this.campaign.targetings.map((t, idx) => ({
          targeting: t,
          meta: this.targetingService.getMetaData(t),
          part: this.campaign.agreement && this.campaign.agreement.parts[idx],
        }));
      }
    }
  }

  private updateCustomerCommentAlert(): void {
    this.hasCustomerCommentAlert = !!this.campaign?.has_customer_comment_alert;
  }

  async acknowledgeCustomerComment(): Promise<void> {
    await this.campaignService.acknowledgeCustomerComment(this.campaign.id);
    this.campaign.has_customer_comment_alert = false;
    this.dashboardStore.setCampaignsWithAlerts(
      this.dashboardStore.state.campaignsWithAlerts.filter((id) => id !== this.campaign.id),
    );
    this.updateCustomerCommentAlert();
  }
}

interface TargetingData {
  targeting: Targeting;
  meta: TargetingMetaData;
  part: AgreementPart;
}
